import { render, staticRenderFns } from "./PORTFOLIOLIKE.vue?vue&type=template&id=55488156"
import script from "./PORTFOLIOLIKE.vue?vue&type=script&lang=js"
export * from "./PORTFOLIOLIKE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports